import { getInlineLoader } from "../Helpers";

export default function MainLoader(props) {
  return (
    <div 
      className="MainLoader mSupportLoading"
    >
      {getInlineLoader({
        variant: "screen",
        centered: false,
        text: "Preparing your dashboard",
        label: "Preparing your dashboard",
      })}
    </div>
  )
}
